import { type ReactNode } from 'react';

export type AlertVariant = 'success' | 'error' | 'info' | 'warning';

export interface AlertProps {
  readonly variant?: AlertVariant;
  readonly children: ReactNode;
  readonly className?: string;
}

/**
 * Status banner — surface success/error/info/warning state in page or form context.
 * Renders a `role="alert"` region styled via `ferro-alert ferro-alert--<variant>`.
 *
 * Mirrors the prop shape of HTHD's `customer-app/src/components/ui/Alert.tsx`
 * so HTHD page ports drop in unchanged: `<Alert variant="error">…</Alert>`.
 */
export function Alert({
  variant = 'info',
  children,
  className = '',
}: AlertProps): JSX.Element {
  const cls = `ferro-alert ferro-alert--${variant}${className ? ` ${className}` : ''}`;
  return (
    <div className={cls} role="alert">
      {children}
    </div>
  );
}
